import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, FasiControllo } from '../../models/-index';

@Injectable()
export class FasiControlloService extends CrudGenericsService<FasiControllo, number> {
  //  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/FasiControllo`);
    //   this.base = `${env.apiUrl}/api/FasiControllo/`;
  }
}
